// src/firebase/config.js
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider, TwitterAuthProvider, FacebookAuthProvider } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'
import { getAnalytics } from 'firebase/analytics'

// App Check (v11 — no getAppCheck)
import {
    initializeAppCheck,
    ReCaptchaV3Provider,
    getToken as getAppCheckToken,
} from 'firebase/app-check'

// ---- Firebase config (env) ----
const firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID || '',
}

// ---- Initialize core SDKs ----
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)
const stor = getStorage(app)
const functions = getFunctions(app)

// ---- Analytics (optional) ----
let analytics
if (firebaseConfig.measurementId) {
    analytics = getAnalytics(app)
}

// ---- Auth providers ----
const googleProvider = new GoogleAuthProvider()
const twitterProvider = new TwitterAuthProvider()
const facebookProvider = new FacebookAuthProvider()

// ---- App Check (reCAPTCHA v3, v11 style) ----
// Requires: VUE_APP_APPCHECK_SITE_KEY set in your .env files
if (process.env.VUE_APP_APPCHECK_SITE_KEY) {
    if (process.env.NODE_ENV !== 'production') {
        // Enable debug token locally (shows a token in console once; add it in App Check console if needed)
        // eslint-disable-next-line no-undef
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }

    // Initialize and keep the instance; v11 passes the instance into getToken()
    const appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(process.env.VUE_APP_APPCHECK_SITE_KEY),
        isTokenAutoRefreshEnabled: true,
    })

    // Flag for components to wait on if needed
    window.__APP_CHECK_READY__ = true
    console.log('✅ App Check initialized with site key:', process.env.VUE_APP_APPCHECK_SITE_KEY ? 'found' : 'MISSING')
    window.__APP_CHECK_INSTANCE__ = appCheck;

    // One-time sanity token fetch (proves site key + domain wiring)
    setTimeout(async () => {
        try {
            const { token } = await getAppCheckToken(appCheck, true) // force on first run
            if (token) console.log('✅ AC_OK token acquired')
        } catch (e) {
            console.error('❌ AC_FAIL', e?.code || e?.name || 'error', e?.message || e)
        }
    }, 0)
} else {
    console.error('❌ App Check not initialized — no VUE_APP_APPCHECK_SITE_KEY in env')
}

export { app, db, auth, stor, functions, googleProvider, twitterProvider, facebookProvider, analytics }
